import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  selectAuth,
  setPrivileges,
  setToken,
} from "../../../../redux/features/auth/auth-slice";
import { clearProfile } from "../../../../redux/features/user/user-slice";
import InstallAppCard from "../../../components/install-app-card/install-app-card";
import { AppRoute } from "../../interfaces/app-routes";
import IPageInfo from "../../interfaces/page-info";
import LogoutModal from "../../shared-components/logout-modal/logout-modal";
import MenuItem from "../../shared-components/sidebar/components/menu-item/menu-item";

interface IProps {
  collapsed?: boolean;
  closeMobileNav?: () => void;
  routes: IPageInfo[];
  logos: string[];
}

const AppMenuContent = (props: IProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { collapsed = false, closeMobileNav, routes, logos } = props;
  const [showLogout, setShowLogout] = useState(false);

  const auth = useSelector(selectAuth);

  const logout = () => {
    localStorage.clear();
    dispatch(setToken(""));
    dispatch(setPrivileges([]));
    dispatch(clearProfile());
    navigate(AppRoute.LOGIN);
  };

  return (
    <Container className="h-100">
      <div className="h-100 d-flex flex-column justify-content-between py-4">
        <Row>
          <Col>
            <Row>
              <Col className="d-flex justify-content-center">
                {collapsed ? (
                  <img
                    src={logos[1]}
                    alt="Oversight Logo"
                    className="mb-4"
                    width={40}
                    height={40}
                  />
                ) : (
                  <img src={logos[0]} alt="Oversight Logo" className="mb-4" />
                )}
              </Col>
            </Row>
            <Row>
              {routes.map((sc) => {
                return sc?.subRoutes
                  ?.filter(
                    (item) =>
                      item.showOnDrawer &&
                      (item.privilege
                        ? auth.privileges.includes(item.privilege)
                        : true),
                  )
                  .map((subRoute) => (
                    <Col
                      xs={12}
                      key={subRoute.path}
                      className="py-2 text-center d-flex justify-content-center"
                    >
                      <MenuItem
                        active={pathname.includes(subRoute.path)}
                        collapsed={props.collapsed}
                        icon={subRoute.icon}
                        to={subRoute.path}
                        text={subRoute.name}
                        onClick={closeMobileNav && closeMobileNav}
                        enableRoute={subRoute.enableRoute}
                        bgColor={subRoute.bgColor}
                        bgColorIcon={subRoute.bgColorIcon}
                      />
                    </Col>
                  ));
              })}
            </Row>
          </Col>
        </Row>
        <div>
          <Row>
            <Col
              xs={12}
              className={`${
                collapsed
                  ? "py-2 text-center d-flex justify-content-center"
                  : "px-1 pb-1"
              }`}
            >
              <InstallAppCard collapsed={collapsed} />
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              className="py-2 text-center d-flex justify-content-center"
            >
              <MenuItem
                active={false}
                collapsed={props.collapsed}
                icon="logout"
                onClick={() => setShowLogout(true)}
                text="Logout"
              />
            </Col>
          </Row>
        </div>
      </div>
      <LogoutModal
        show={showLogout}
        onCancel={() => setShowLogout(false)}
        onClose={() => setShowLogout(false)}
        onConfirm={() => {
          setShowLogout(false);
          logout();
        }}
      />
    </Container>
  );
};

export default AppMenuContent;
